import Vue from 'vue'
import colorMixin from '../mixins/color'

Vue.mixin(colorMixin)
